import * as React from "react";
import { PulseLoader } from "react-spinners";
import styled from "styled-components";

import { Colors } from "src/library/utils";

import type { ILoaderStyled } from "./LoadingSpinner";

interface IPulseLoaderSpinner {
  size?: number;
  color: keyof Colors;
}

/**
 * Custom styled PulseLoader
 */
const PulseLoaderStyled = styled(PulseLoader).attrs(({ customColor, theme }: ILoaderStyled) => ({ color: theme.colors[ customColor ] }))<ILoaderStyled>``;

/**
 * A PulseLoader loading spinner
 */
const PulseLoaderSpinner = ({ size, color }: IPulseLoaderSpinner) => {
  const sizeDefault = 10;

  // Set option props with default values
  size = size || sizeDefault;

  return (
    <PulseLoaderStyled
      customColor={color}
      size={size}
      margin={`${(size * 0.25).toString()}px`}
    />
  );
};

export default PulseLoaderSpinner;
